import React, { useEffect, useState } from 'react';

/**
 * Experience page fetches professional history from the backend and
 * renders each entry. Each experience includes a company heading,
 * job title, location, dates and a list of bullet points parsed
 * from the description string. When the API request fails the
 * component gracefully falls back to an empty list.
 */

function Experience() {
  const [experiences, setExperiences] = useState([]);

  useEffect(() => {
    fetch('https://api.virajpargaonkar.me/api/experiences')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to fetch experiences');
        }
        return res.json();
      })
      .then((data) => {
        setExperiences(data);
      })
      .catch((err) => {
        console.error(err);
        setExperiences([]);
      });
  }, []);

  const formatDateRange = (startDate, endDate) => {
    const options = { year: 'numeric', month: 'short' };
    const start = new Date(startDate);
    const startStr = start.toLocaleDateString('en-US', options);
    let endStr = 'Present';
    if (endDate) {
      const end = new Date(endDate);
      endStr = end.toLocaleDateString('en-US', options);
    }
    return `${startStr} – ${endStr}`;
  };

  return (
    <>
      <section className="page-banner">
        <div className="container">
          <h1>Professional Experience</h1>
          <p>A detailed overview of my work history and contributions.</p>
        </div>
      </section>
      <main className="page-content">
        <div className="container experience-detail">
          {experiences.map((exp) => {
            const bullets = exp.description ? exp.description.split('\n') : [];
            return (
              <div key={exp.id} className="experience-entry" data-aos="fade-up">
                <h2>{exp.company}</h2>
                <h3>
                  {exp.title} · {exp.location} · {formatDateRange(exp.startDate, exp.endDate)}
                </h3>
                <ul>
                  {bullets.map((b, idx) => (
                    <li key={idx}>{b}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </main>
    </>
  );
}

export default Experience;